import PropTypes from 'prop-types';

import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableRow 
} from '@mui/material';

const ProfitShareTotal = ({totalToClient, genericProfitShare}) => {
  return (
    <div className="mb-6">
      <TableContainer 
        sx={{
        borderCollapse: 'separate',
        borderRadius: '15px',
        border: '1px solid rgb(224, 224, 224)',
      }}>
        <Table aria-label="ProfitShareRevenue">
          <TableBody>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Profit Share</TableCell>
              <TableCell align='right'>{`${(genericProfitShare * 100).toFixed(2)}%`}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{fontWeight: 'bold'}}>Profit Share Earned</TableCell>
              <TableCell align='right'>{`£${totalToClient.toFixed(2)}`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}

export default ProfitShareTotal;

ProfitShareTotal.propTypes = {
	totalToClient: PropTypes.number.isRequired,
    genericProfitShare: PropTypes.number.isRequired,
};